<template>
  <div class="rechargeBox">
    <div class="payment-top acea-row row-column row-center-wrapper">
      <span class="name">我的账户</span>
      <div class="pic">
        ￥<span class="pic-font">{{ now_money || 0 }}</span>
      </div>
    </div>
    <div class="recharge">
      <div class="nav acea-row row-around row-middle">
        <div
            class="item"
            :class="active === index ? 'on' : ''"
            v-for="(item, index) in navRecharge"
            :key="index"
            @click="navRecharges(index)"
        >
          {{ item }}
        </div>
      </div>
      <div class="info-wrapper">
        <div v-if="active">
          <div class="money">
            <span>￥</span>
            <input type="number" placeholder="0.00" v-model="money" />
          </div>
          <div class="tip-box">
            <span class="tip">提示：</span>
            <div class="tip-samll">
              当前可转入收益：
              <span class="font-color"
              >￥{{ userInfo.brokerage_price || 0 }}</span
              >
            </div>
          </div>
        </div>
        <div class="picList acea-row row-between mt-20" v-if="!active">

          <div
              class="pic-box pic-box-color acea-row row-center-wrapper"
              @click="picCharge(picList.length)"
          >
            <input
                type="text"
                placeholder="备注"
                v-model="money"
                class="pic-box-money pic-number-pic"
            />
          </div>
        </div>


        <div class="uploadpay item acea-row row-between">
          <div class="title acea-row row-between-wrapper" style="width: 100%;">
            <div>上传付款凭证</div>
            <div class="tip">( 最多可上传3张 )</div>
          </div>

          <div class="upload acea-row row-middle" >
            <div style="width:100%">


              <div
                  class="pictrue"
                  v-for="(img, index) in refund_reason_wap_img"
                  :key="img"
              >
                <img :src="img" />


                <div
                    class="iconfont icon-guanbi1 font-color-red"
                    @click="refund_reason_wap_img.splice(index, 1)"
                ></div>
              </div>
            </div>
            <div style="margin: 0.5rem 0;border: 1px solid #e8e8e8;padding: 0.2rem;">
              <VueCoreImageUpload
                  class="btn btn-primary"
                  :crop="false"
                  compress="80"
                  @imageuploaded="imageuploaded"
                  :headers="headers"
                  :max-file-size="5242880"
                  :credentials="false"
                  inputAccept="image/*"
                  inputOfFile="file"
                  :url="url"
                  v-if="refund_reason_wap_img.length < 3"
              >
                <div class="pictrue acea-row row-center-wrapper row-column">
                  <span class="iconfont icon-icon25201"></span>
                  <div>上传凭证</div>
                </div>
              </VueCoreImageUpload>
            </div>

          </div>
        </div>

        <div class="acea-row row-column">
          <div class="tip mt-30">注意事项：</div>
          <div class="tip-samll" v-for="item in rechargeAttention" :key="item">
            {{ item }}
          </div>
        </div>
        <div class="pay-btn bg-color-red" @click="recharge">
          {{ active ? "立即转入" : "立即充值" }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import { isWeixin } from "@utils/index";
import { wechatEvevt,wechat,pay,openShareAll,oAuth } from "@libs/wechat";
import WechatJSSDK from "wechat-jssdk/dist/client.umd";
import { imageBase64,getWechatConfig,getShare } from "@api/public";
import { rechargeWechat, getRechargeApi } from "@api/user";
import VueCoreImageUpload from "vue-core-image-upload";
import { add, sub } from "@utils/bc";
import { trim, VUE_APP_API_URL } from "@utils";
export default {
  name: "Recharge",
  components: {
    VueCoreImageUpload
  },
  props: {},
  data: function() {
    return {
      url: `${VUE_APP_API_URL}/upload/image`,
      headers: {
        "Authori-zation": "Bearer " + this.$store.state.app.token
      },
      navRecharge: [ "账户充值"],//, "收益导入"
      active: 0,
      payType: ["weixin"],
      from: isWeixin() ? "weixin" : "weixinh5",
      money: "",
      now_money: "",
      picList: [],
      activePic: 0,
      numberPic: "",
      rechar_id: 0,
      rechargeAttention: [],
      refund_reason_wap_img: [],
    };
  },
  mounted: function() {
    this.getRecharge();
  },
  methods: {
    imageuploaded(res) {
      if (res.status !== 200)
        return this.$dialog.error(res.msg || "上传图片失败");
      this.refund_reason_wap_img.push(res.data.url);
    },
    /**
     * 充值不知道费用选择
     */
    getRecharge() {
      getRechargeApi()
          .then(res => {


            this.picList = res.data.recharge_quota;
            if (this.picList[0]) {
              this.rechar_id = this.picList[0].id;
              this.numberPic = this.picList[0].price;
            }
            this.now_money = res.data.account_money;
            this.rechargeAttention = res.data.rechargeAttention || [];
          })
          .catch(res => {
            this.$dialog.toast({ mes: res });
          });
    },
    /**
     * 选择金额
     */
    picCharge(idx, item) {
      this.activePic = idx;
      if (item === undefined) {
        this.rechar_id = 0;
        this.numberPic = "";
      } else {
        this.money = "";
        this.rechar_id = item.id;
        this.numberPic = item.price;
      }
    },
    navRecharges: function(index) {
      this.active = index;
      this.rechar_id = this.picList[0].id;
      this.numberPic = this.picList[0].price;
      this.activePic = 0;
      this.money = "";
    },
    recharge: function() {
         let that = this;
          rechargeWechat({
          price: this.money,
          refund_reason_wap_img: this.refund_reason_wap_img.join(","),
        }).then(res => {
          that.$dialog.success(res.msg).then(() => {
            this.$router.push({ path: '/user/recharge_list/' });
          });
        })
        .catch(res => {
          that.$dialog.toast({ mes: res.msg });
        });

    }
  }
};
</script>
<style scoped>
.rechargeBox {
  height: 100%;
  background: #fff;
}
#iframe {
  display: none;
}
.pic-box-color-active {
  background-color: #146268 !important;
  color: #fff !important;
}
.pic-box-active {
  width: 2.16rem;
  height: 1.2rem;
  background-color: #146268;
  border-radius: 0.2rem;
}
.picList {
  margin-bottom: 0.3rem;
  margin-top: 0.3rem;
}
.font-color {
  color: #146268;
}
.recharge {
  border-radius: 0.1rem;
  width: 100%;
  background-color: #fff;
  margin: 0.2rem auto 0 auto;
  padding: 0.3rem;
  border-top-right-radius: 0.39rem;
  border-top-left-radius: 0.39rem;
  margin-top: -0.45rem;
  box-sizing: border-box;
}
.recharge .nav {
  height: 0.75rem;
  line-height: 0.75rem;
  padding: 0 1rem;
}
.recharge .nav .item {
  font-size: 0.3rem;
  color: #333;
}
.recharge .nav .item.on {
  font-weight: bold;
  border-bottom: 0.04rem solid #146268;
}
.recharge .info-wrapper {
}
.recharge .info-wrapper .money {
  margin-top: 0.6rem;
  padding-bottom: 0.2rem;
  border-bottom: 1px dashed #ddd;
  text-align: center;
}
.recharge .info-wrapper .money span {
  font-size: 0.56rem;
  color: #333;
  font-weight: bold;
}
.recharge .info-wrapper .money input {
  display: inline-block;
  width: 3rem;
  font-size: 0.84rem;
  text-align: center;
  color: #282828;
  font-weight: bold;
  padding-right: 0.7rem;
}
.recharge .info-wrapper .money input::placeholder {
  color: #ddd;
}
.recharge .info-wrapper .money input::-webkit-input-placeholder {
  color: #ddd;
}
.recharge .info-wrapper .money input:-moz-placeholder {
  color: #ddd;
}
.recharge .info-wrapper .money input::-moz-placeholder {
  color: #ddd;
}
.recharge .info-wrapper .money input:-ms-input-placeholder {
  color: #ddd;
}
.tip {
  font-size: 0.28rem;
  color: #333333;
  font-weight: 800;
  margin-bottom: 0.14rem;
}
.tip-samll {
  font-size: 0.24rem;
  color: #333333;
  margin-bottom: 0.14rem;
}
.tip-box {
  margin-top: 0.3rem;
}
.recharge .info-wrapper .tips span {
  color: #ef4a49;
}
.recharge .info-wrapper .pay-btn {
  display: block;
  width: 100%;
  height: 0.86rem;
  margin: 0.5rem auto 0 auto;
  line-height: 0.86rem;
  text-align: center;
  color: #fff;
  border-radius: 0.5rem;
  font-size: 0.3rem;
  font-weight: bold;
}
.payment-top {
  width: 100%;
  height: 3.5rem;
  background-color: #146268;
}
.payment-top .name {
  font-size: 0.26rem;
  color: rgba(255, 255, 255, 0.8);
  margin-top: -0.38rem;
  margin-bottom: 0.3rem;
}
.payment-top .pic {
  font-size: 0.32rem;
  color: #fff;
}
.payment-top .pic-font {
  font-size: 0.78rem;
  color: #fff;
}
.picList .pic-box {
  width: 100%;
  height: auto;
  border-radius: 0.2rem;
  margin-top: 0.21rem;
  padding: 0.2rem 0;
}
.pic-box-color {
  background-color: #f4f4f4;
  color: #656565;
}
.pic-number {
  font-size: 0.22rem;
}
.pic-number-pic {
  font-size: 0.38rem;
  margin-right: 0.1rem;
  text-align: center;
}
.pic-box-money {
  width: 100%;
  display: block;
}
</style>
